import { supabase } from './supabase';

const client = () => {
  if (!supabase) throw new Error('Konto er ikke tilsluttet. Kontakt din rådgiver.');
  return supabase;
};

export async function requestPasswordReset(email: string) {
  const address = email.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address))
    throw new Error('Indtast en gyldig e-mailadresse.');
  const { error } = await client().auth.resetPasswordForEmail(address, {
    redirectTo: `${window.location.origin}/?recovery=1`,
  });
  if (error) throw new Error('Loginhjælp kunne ikke sendes. Prøv igen eller kontakt din rådgiver.');
}

export async function updatePassword(
  password: string,
  confirmation: string,
  expectedUserId: string,
) {
  if (password.length < 10) throw new Error('Adgangskoden skal være mindst 10 tegn.');
  if (password !== confirmation) throw new Error('Adgangskoderne er ikke ens.');
  const auth = client().auth;
  const { data: before, error: beforeError } = await auth.getSession();
  if (beforeError || !before.session || before.session.user.id !== expectedUserId)
    throw new Error('Åbn loginhjælpen i din e-mail, eller log ind på den oprindelige konto først.');
  const { data: verified, error: verifyError } = await auth.getUser(before.session.access_token);
  const { data: current } = await auth.getSession();
  if (
    verifyError ||
    verified.user?.id !== expectedUserId ||
    current.session?.user.id !== expectedUserId
  )
    throw new Error('Kontoen skiftede under handlingen. Ingen adgangskode er ændret.');
  // Pin the mutation to the original access token. updateUser() rereads a mutable
  // session internally and could otherwise mutate a newly logged-in account.
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url || !key) throw new Error('Konto er ikke tilsluttet.');
  const response = await fetch(`${url.replace(/\/$/, '')}/auth/v1/user`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${before.session.access_token}`,
      apikey: key,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
    signal: AbortSignal.timeout(15000),
  });
  if (!response.ok)
    throw new Error('Adgangskoden kunne ikke ændres. Åbn et nyt link fra din e-mail og prøv igen.');
  const { data: after, error: afterError } = await auth.getSession();
  if (afterError || after.session?.user.id !== expectedUserId)
    throw new Error(
      'Kontoen skiftede under handlingen. Kontrollér adgangskoden på den oprindelige konto.',
    );
}
